import React, { ReactNode, useCallback, useRef, useState } from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { useUserState } from "../../../context";
import { QUERIES } from "../../../graphql";
import { Building } from "../../../graphql/models";
import { BuildingForm } from "./building_form";

import useBuildingsStyle from "./buildings.style";

function BuildingsPage(props: any) {
  const classes = useBuildingsStyle();
  const { userRole } = useUserState();

  const tableRef = useRef();

  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formBuilding, setFormBuilding] = useState<Building | undefined>(
    void 0
  );

  const addNewBuilding = () => {
    setFormBuilding({} as Building);
    setFormDialogOpened(true);
  };

  const editBuilding = (building) => {
    setFormBuilding({
      ...building,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormBuilding(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback(
    (row) => {
      const actions: ReactNode[] = [];
      if (userRole === "system_admin") {
        actions.push(<EditButton onClick={() => editBuilding(row)} />);
      }

      return actions;
    },
    [userRole]
  );

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar
          title={"Palazzi"}
          actions={[
            <Button
              key="addNewBuilding"
              variant="contained"
              color="primary"
              onClick={() => addNewBuilding()}
            >
              Aggiungi Nuovo
            </Button>,
          ]}
        />
        <GqlTable
          ref={tableRef}
          columns={["", "Nome"].map((v, index) => (
            <TableCell key={index}>{v}</TableCell>
          ))}
          query={QUERIES.BUILDINGS("full")}
          queryResultDataField="buildings"
          rows={(row) => (
            <>
              <TableCell width={1}>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.name}</TableCell>
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi Palazzo"}
        >
          <BuildingForm
            value={formBuilding}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(BuildingsPage);
